import { useContext } from "react";
import UserManagementContext from "../context/userManagementProvider";

const useUserManagementTabs = () => {
  const { tabs, setTabs } = useContext(UserManagementContext);
            
  return {
    tabs,
    setTabs,
  };
};

export default useUserManagementTabs;
